<template>
    <jt-data-table
      ref="jtDataTable"
      :fields="datatableController.datatable.columns"
      singleselect
      :nm-interface="datatableController.interfaceName"
    ></jt-data-table>
</template>
<script>
import { JtDataTable } from 'jtech-webcomps'
import { DatatableController } from './DatatableController'
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    JtDataTable
  }
})
export default class DatatableExample extends Vue {
    datatableController = DatatableController.getInstance()

    async mounted () {
      await this.datatableController.fetchDatatable()
    }
}
</script>
